<template>
  <div
    v-if="acc"
    class="user-center-page"
  >
    <div class="top-gradient" />

    <main class="user-center-content">
      <section class="profile-panel">
        <div class="profile-avatar">
          <img
            v-if="app && app.fuli1"
            :src="app.fuli1"
            alt=""
          >
        </div>
        <div class="profile-details">
          <div class="profile-name-row">
            <strong>{{ acc.mobile }}</strong>
         <!--   <span
              v-if="acc.vip"
              class="vip-label"
            >{{ acc.vip.name }}</span> -->
          </div>
          <p>{{ $t("d.creditscore") }}: {{ acc.credit || 0 }}</p>
     <!--     <div class="invite-code-row">
            <span>{{ $t("d.code") }}: {{ acc.yaocode || "-" }}</span>
            <button
              type="button"
              class="copy-button"
              @click="copyYaocode"
            >
              {{ $t("invest_bank.copy") }}
            </button>
          </div> -->
        </div>
        <button
          type="button"
          class="settings-button"
          :aria-label="$t('user.setting')"
          @click="goTo('/set')"
        >
          <van-icon
            name="setting-o"
            size="25"
          />
        </button>
      </section>

      <section
        class="balance-card"
        :aria-label="$t('userCenter.balance')"
      >
        <span class="balance-label">{{ $t("userCenter.balance") }}</span>
        <strong>{{ formattedBalance }}</strong>
      </section>

      <section class="quick-actions">
        <button
          v-for="action in quickActions"
          :key="action.labelKey"
          type="button"
          class="quick-action"
          :class="action.className"
          @click="goTo(action.path)"
        >
          {{ $t(action.labelKey) }}
        </button>
      </section>

      <section class="account-menu">
        <button
          v-for="item in menuItems"
          :key="item.labelKey"
          type="button"
          class="menu-item"
          @click="goTo(item.path)"
        >
          <img
            v-if="item.iconImage"
            :src="item.iconImage"
            alt=""
            class="menu-image"
          >
          <van-icon
            v-else
            :name="item.iconName"
            class="menu-icon"
          />
          <span>{{ $t(item.labelKey) }}</span>
          <van-icon
            name="arrow"
            class="menu-arrow"
            aria-hidden="true"
          />
        </button>
      </section>

      <button
        type="button"
        class="logout-button"
        @click="logout"
      >
        {{ $t("userCenter.logout") }}
      </button>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Icon);

export default {
  name: "User",
  data() {
    return {
      acc: null,
      app: null,
      quickActions: [
        {
          labelKey: "userCenter.informationNotice",
          path: "/notice",
          className: "unverified-action"
        },
        {
          labelKey: "userCenter.exchangePoints",
          path: "/cash",
          className: "exchange-action"
        }
      ],
      menuItems: [
        {
          labelKey: "userCenter.basicInformation",
          path: "/moneybag",
          iconImage: require("../images/ban5/jb.png")
        },
        // {
        //   labelKey: "userCenter.bankCardInfo",
        //   path: "/account",
        //   iconImage: require("../images/ban5/czjf.13452b89.png")
        // },
        {
          labelKey: "userCenter.cryptocurrencyWallet",
          path: "/account",
          iconImage: require("../images/ban5/qianbao.png")
        },
        // {
        //   labelKey: "userCenter.exchangeRecord",
        //   path: "/cashlist",
        //   iconImage: require("../images/ban5/txjls.b557a239.png")
        // },
        {
          labelKey: "userCenter.dataRecords",
          path: "/order",
          iconImage: require("../images/ban5/ys1.png")
        },
        {
          labelKey: "userCenter.unverified",
          path: "/buy/1",
          iconImage: require("../images/ban5/txjls.png")
        // },
        // {
        //   labelKey: "userCenter.modifyLoginPassword",
        //   path: "/setpwd",
        //   iconImage: require("../images/ban5/dl.f3672665.png")
        // },
        // {
        //   labelKey: "userCenter.setFinancePassword",
        //   path: "/setpaypwd",
        //   iconImage: require("../images/ban5/dl.f3672665.png")
        }
      ]
    };
  },
  computed: {
    formattedBalance() {
      const balance = Number(this.acc && this.acc.money);

      return Number.isFinite(balance) ? balance.toFixed(2) : "0.00";
    }
  },
  created() {
    this.$parent.footer("user");
  },
  mounted() {
    if (localStorage.getItem("token") === null) {
      this.$router.push("/login");
      return;
    }

    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      Fetch("/index/webconfig").then((response) => {
        this.app = response.data || null;
      });

      Fetch("/user/info").then((response) => {
        this.acc = response.data || {};
      });
    },
    goTo(path) {
      this.$router.push(path);
    },
    copyYaocode() {
      const invitationCode = this.acc && this.acc.yaocode;

      if (!invitationCode) {
        return;
      }

      const text = String(invitationCode);

      if (this.copyTextBySelection(text)) {
        this.showCopySuccess();
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.showCopySuccess();
        }).catch(() => {});
      }
    },
    copyTextBySelection(text) {
      const input = document.createElement("textarea");
      input.value = text;
      input.setAttribute("readonly", "readonly");
      input.style.position = "fixed";
      input.style.left = "-9999px";
      input.style.top = "0";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);

      let copied = false;

      try {
        copied = document.execCommand("copy");
      } catch (error) {
        copied = false;
      }

      document.body.removeChild(input);
      return copied;
    },
    showCopySuccess() {
      this.$toast({
        background: "#07c160",
        message: this.$t("invest_qrcode.copySucceeded")
      });
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.replace("/");
    }
  }
};
</script>

<style lang="less" scoped>
.user-center-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  // background: #fff url(../images/ban5/g.png) no-repeat top center / 100% auto;
}

.top-gradient {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 180px;
  background: linear-gradient(100deg, #dd55bf 0%, #703fc6 100%);
}

.user-center-content {
  position: relative;
  padding: 14px 20px 76px;
}

.profile-panel {
	display: flex;
	align-items: center;
	min-height: 80px;
	color: #fff;
	margin-top: 20px;
}

.profile-avatar {
  flex: 0 0 auto;
  margin-left: 10px;
  margin-right: 5px;
  width:60px;
  height: 60px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
}

.profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-details {
  min-width: 0;
  margin-left: 10px;
}

.profile-name-row,
.invite-code-row {
  display: flex;
  align-items: center;
  min-width: 0;
}

.profile-name-row strong {
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vip-label {
  flex: 0 0 auto;
  margin-left: 6px;
  padding: 0 8px;
  border-radius: 10px;
  background: #ffd424;
  color: #151515;
  font-size: 10px;
  font-weight: 600;
  line-height: 20px;
}

.profile-details p,
.invite-code-row span {
	margin: 0;
	color: #fff;
	font-size: 12px;
	line-height: 30px;
}

.invite-code-row span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-button {
  flex: 0 0 auto;
  height: 20px;
  margin-left: 8px;
  padding: 0 8px;
  border: 0;
  border-radius: 5px;
  background: #232f3e;
  color: #ffcd00;
  font-size: 10px;
  line-height: 20px;
}

.settings-button {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 14px;
  line-height: 28px;
}

.balance-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 86px;
  margin-top: 15px;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 12px;
  background: url(../images/ban5/yue.png) no-repeat center / 100% 100%;
  color: #fff;
}

.balance-label {
  font-size: 16px;
  line-height: 23px;
}

.balance-card strong {
  margin-top: 2px;
  font-size: 16px;
  font-weight: bolder;
  line-height: 25px;
}

.quick-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 8px;
}

.quick-action {
  height: 52px;
  padding: 0 6px;
  overflow: hidden;
  border: 0;
  border-radius: 14px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  color: #fff;
  font-size: 14px;
  line-height: 52px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.unverified-action {
  background-image: url(../images/ban5/1.png);
}

.exchange-action {
  background-image: url(../images/ban5/yue.png);
}

.account-menu {
  margin: 14px -20px 0;
  padding: 10px 20px 4px;
  background: rgba(255, 255, 255, 0.96);
  border-top: 6px solid #f7f7f7;
}

.menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 56px;
  padding: 0 4px;
  border: 0;
  background: transparent;
  color: #4a3197;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}

.menu-image {
  flex: 0 0 auto;
  width: 35px;
  height: 35px;
  margin-right: 12px;
  object-fit: contain;
}

.menu-arrow {
  margin-left: auto;
  color: #111;
  font-size: 14px;
}

.logout-button {
  display: block;
  width: calc(100% - 24px);
  height: 45px;
  margin: 20px auto 0;
  border: 0;
  border-radius: 5px;
  background: linear-gradient(100deg, #df54be 0%, #703dc6 100%);
  color: #fff;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}
</style>
